// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QhK8F","toggle":"styles_toggle__3VJ64","preview":"styles_preview__2mQr-"};